import api from './api';

const partyService = {
  getAll:       (params = {}) => api.get('/parties', { params }).then(r => r.data),
  getById:      (id)          => api.get(`/parties/${id}`).then(r => r.data),
  create:       (data)        => api.post('/parties', data).then(r => r.data),
  update:       (id, data)    => api.put(`/parties/${id}`, data).then(r => r.data),
  delete:       (id)          => api.delete(`/parties/${id}`).then(r => r.data),
  lookupGstin:  (gstin)       => api.get(`/parties/gstin/${gstin}`).then(r => r.data),
};

export default partyService;
